/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：690
 */

"use strict"

export { o as a }
import * as /* [auto-meaningful-name] */Module_2645 from /* 2645 */"./2645"
import /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_798 from /* 798 */"../../../551/1211/709/798/index"
function o() {
  return Module_2645.a() || Module_798.a
}
export default o
